import { render, staticRenderFns } from "./BarChartSvg.vue?vue&type=template&id=d34e6d14&"
import script from "./BarChartSvg.vue?vue&type=script&lang=js&"
export * from "./BarChartSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports